import React from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';

interface Props extends React.HTMLProps<HTMLHeadingElement> {
  variant?: 'h2' | 'h3' | 'h4';
}

const Title: React.FC<Props> = ({
  children,
  variant: Tag = 'h2',
  className,
  ...rest
}) => {
  return (
    <Tag className={classNames(styles.root, styles[Tag], className)} {...rest}>
      {children}
    </Tag>
  );
};

export default Title;
